module.exports = __webpack_public_path__ + "static/crate_and_barrel@2x.787ec87d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2x/crate_and_barrel@2x.jpg
// module id = 494
// module chunks = 265343770855089